module.exports = __webpack_public_path__ + "static/media/tyr.11235ce8.png";